import { InputField, Textarea } from '@innovationnorway/component-library';
import { Button } from '@innovationnorway/cl-react';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { parseGoalReviewComment } from 'src/features/siva/utils';

type FormData = {
  comment: string;
  expectedValue: number;
};

type Props = {
  onSubmit: (formData: FormData) => void;
  onCancel: () => void;
  defaultValues?: Partial<FormData>;
  isLoading?: boolean;
};

const SivaGoalReviewForm: React.FC<Props> = ({ onSubmit, onCancel, defaultValues, isLoading }) => {
  const parsedDefaultValues = defaultValues?.comment
    ? parseGoalReviewComment(defaultValues.comment)
    : undefined;

  const form = useForm<FormData>({
    defaultValues: {
      comment: parsedDefaultValues?.sivaComment || defaultValues?.comment || '',
      expectedValue: parsedDefaultValues?.expectedValue || defaultValues?.expectedValue || 0,
    },
  });

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="goal-feedback-card__notification">
      <Controller
        control={form.control}
        name="comment"
        render={({ field, fieldState }) => (
          <Textarea
            label="Kommentar fra SIVA"
            className="goal-feedback-card-notification__textarea"
            errorMsg={fieldState.error?.message}
            {...field}
          />
        )}
      />

      <label htmlFor="goalFeedbackInput" className="goal-feedback-card-notification-input__label">
        Opprinnelig måltall
      </label>
      <small className="goal-feedback-card-notification-input__description">
        Skriv måltallsverdien som SIVA gir tilbakemelding på
      </small>
      <Controller
        control={form.control}
        name="expectedValue"
        render={({ field, fieldState }) => (
          <InputField
            id="goalFeedbackInput"
            type="number"
            className="goal-feedback-card-notification__input"
            {...field}
            errorMsg={fieldState.error?.message}
          />
        )}
      />

      <div className="display--flex gap--2">
        <Button type="submit" loading={isLoading}>
          Lagre kommentar og opprinnelig måltall
        </Button>
        <Button type="button" variant="secondary" onClick={onCancel}>
          Avbryt
        </Button>
      </div>
    </form>
  );
};

export default SivaGoalReviewForm;
